import { useState } from 'react';
import { announcements } from '@/mocks/home';

export default function AnnouncementSection() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section id="announcement" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
          <div className="lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20website%20homepage%20screenshot%20mockup%20on%20laptop%20screen%2C%20clean%20minimalist%20interface%20design%2C%20warm%20color%20scheme%20with%20crimson%20accents%2C%20professional%20web%20design%2C%20soft%20lighting%2C%20elegant%20layout&width=1200&height=750&seq=announce-screenshot&orientation=landscape"
                alt="91在线视频官网截图"
                className="w-full h-auto object-cover"
              />
              <div className="absolute top-4 left-4 flex gap-2">
                <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full">
                  官网首页
                </span>
                <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full">
                  最新地址
                </span>
                <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full">
                  安全入口
                </span>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 mb-3">
              <i className="ri-broadcast-line text-accent-500 text-xl"></i>
              <span className="text-sm font-semibold text-accent-600 tracking-wide uppercase">最新公告</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              网站最新入口地址
            </h2>
            <p className="text-foreground-600 mb-8 leading-relaxed">
              为确保您始终能够稳定访问91在线视频，请收藏本页面获取最新有效入口地址。我们实时更新，保障您的访问体验。
            </p>

            <div className="flex gap-2 mb-6 flex-wrap">
              {announcements.map((item, idx) => (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(idx)}
                  className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                    activeTab === idx
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <span className={`inline-block w-2 h-2 rounded-full mr-2 ${
                    idx === 0 ? 'bg-accent-400' : idx === 1 ? 'bg-green-400' : 'bg-secondary-400'
                  }`}></span>
                  {item.badge}
                </button>
              ))}
            </div>

            <div className="bg-foreground-900 rounded-2xl p-6 md:p-8 transition-all duration-300">
              <span className="inline-block px-3 py-1 bg-accent-500/20 text-accent-400 text-xs font-semibold rounded-full mb-4">
                {announcements[activeTab].badge}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3">
                {announcements[activeTab].title}
              </h3>
              <p className="text-foreground-400 text-sm leading-relaxed mb-5">
                {announcements[activeTab].description}
              </p>
              <div className="flex items-center gap-3 p-3 bg-foreground-800/50 rounded-xl">
                <i className="ri-link text-accent-400 text-lg"></i>
                <span className="text-accent-300 text-sm font-mono break-all">
                  {announcements[activeTab].url}
                </span>
                <button
                  onClick={() => navigator.clipboard.writeText(announcements[activeTab].url)}
                  className="whitespace-nowrap ml-auto px-4 py-1.5 bg-accent-500 text-white rounded-full text-xs font-medium hover:bg-accent-600 transition-colors cursor-pointer"
                >
                  复制链接
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}